import axios, { AxiosInstance } from "axios";
import { store } from "../../redux/store/store";
import { showBlockingSnackbar } from "../../redux/slices/blockingSnackbarSlice";

const CMS_API_KEY = process.env.REACT_APP_CMS_API_KEY;
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const cmsAxios: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "cms-api-key": CMS_API_KEY,
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  },
  // timeout: 10000,
});

cmsAxios.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

cmsAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken");
      store.dispatch(showBlockingSnackbar({ countdown: 5 }));
    }
    return Promise.reject(error);
  }
);

export const loginAxios: AxiosInstance = axios.create({
  baseURL: BASE_URL,
});
